<div class="sensor-detail container-fluid">
  <div class="sensor-header">
    <div class="sensor-header-image">
      <i class="fa fa-microchip" aria-hidden="true"></i>
    </div>
    <div class="sensor-detail-info-box">
      <div class="sensor-link-loc">Sensors</div>
      <h1>
        <div class="sensor-status-text">{{this.sensor.instrumentType}}</div>
        <div class="sensor-status">
          <div [ngClass]="'sensor-status-icon ' + this.sensor.status.toLowerCase().replace(' ', '-')"></div>
          <div class="sensor-status-message">
            {{this.sensor.status}}
          </div>
        </div>

        <div *ngIf="this.rights.get('update')" class="sensor-status-option-tab">
          <ul class="sensor-status-option-tab-list">
            <li id="state-list"
                (clickOutside)="disableModeMenu(sensorStatus?.sensorStates)"
                (click)="toggleModeMenu(sensorStatus?.sensorStates);"
                class="default">
              Select mode <i class="fa fa-angle-down icone" aria-hidden="true"></i>
            </li>

            <li id="sensor-off"
                *ngIf="sensorStatus?.isSensorActive"
                (click)="sensorStatus?.changeSensorStateMessage(sensorStatus?.isSensorActive, selectModeMsg); changeModeModal.show()"
                [hidden]="sensorStates[sensorStatus?.sensorStateIndex].hidden">
              <h1>{{ sensorStates[0]?.name }}</h1>
              <h2>{{ sensorStates[0]?.info }}</h2>
            </li>

            <li id="sensor-not-publishing"
                *ngIf="!sensorStatus?.isSensorActive || sensorStatus?.isPublishing"
                (click)="sensorStatus?.setUIPublishingState(false, selectModeMsg); changeModeModal.show()"
                [hidden]="sensorStates[sensorStatus?.sensorStateIndex].hidden">
              <h1>{{ sensorStates[1]?.name }}</h1>
              <h2>{{ sensorStates[1]?.info }}</h2>
            </li>

            <li id="sensor-publishing"
                *ngIf="!sensorStatus?.isSensorActive || !sensorStatus?.isPublishing"
                (click)="sensorStatus?.setUIPublishingState(true, selectModeMsg); changeModeModal.show()"
                [hidden]="sensorStates[sensorStatus?.sensorStateIndex].hidden">
              <h1>{{ sensorStates[2]?.name }}</h1>
              <h2>{{ sensorStates[2]?.info }}</h2>
            </li>

          </ul>
        </div>
        <div class="sensor-feature-list">
          <li hidden="true">{{this.updateSingleCurrentFeature(this.streamNotificationService.getFeature())}}</li>
          <ul class="sensor-feature-list-options fa-stack" (mouseenter)="this.showFeatureList = true" (mouseleave)="this.showFeatureList = false">
            <li *ngFor="let feature of this.featureList" id="feature-state-list"
                [ngClass]="feature?.id === this.selectedFeature?.id ? (this.showFeatureList ? 'active' : '') : (!this.showFeatureList ? 'hidden': '')" (click)="this.setSelectedFeature(feature)">
              {{feature?.name}}
              <span>
                <i [ngClass]="!this.showFeatureList && this.featureList.length > 1 ? 'fa fa-angle-down icone' : feature?.id === this.selectedFeature?.id && this.featureList.length >1 ? 'fa fa-angle-left icone' : ''"></i>
                <i [ngClass]="(feature.active === undefined || feature.active) ? '' : 'fa fa-ban icone'"></i>
              </span>
            </li>
          </ul>
        </div>
      </h1>
      <h2>{{this.sensor?.name}}</h2>
    </div>
    <div class="sensor-tabs">
      <ul>
        <li *ngFor="let tab of this.optionTabs" [routerLink]="tab.url"
            [routerLinkActiveOptions]="{}" routerLinkActive="active" [hidden]="!tab.visible">{{tab.label}}
        </li>
      </ul>
    </div>
  </div>
  <div class="sensor-detail-panel">
    <router-outlet></router-outlet>
  </div>
</div>

<app-modal #changeModeModal>
  <div class="app-modal-header" style="margin-bottom: 32px;">
    Change mode to {{ this.selectModeMsg?.mode }}
  </div>
  <div class="app-modal-body" style="margin-top: -56px;">
    You are changing the status of the sensor. Please describe the reason of changing and press save.<br/><br/>
    <span>Name: {{this.selectModeMsg?.user}}</span><br/>
    <span>Date: {{this.selectModeMsg?.date | date : "dd-MM-yyyy"}}</span><br/>
    <span>Time: {{this.selectModeMsg?.date | date : "HH:mm"}}</span><br/><br/>
    <span>Reason of change*</span><br/>
    <textarea id="text-area" [(ngModel)]="this.selectModeMsg.reason" [ngClass]="{'require': this.formError}"></textarea>
    <div class="formError" [hidden]="!this.formError" (hiddenChange)="this.formError = $event">* Required field</div>
  </div>
  <div class="app-modal-footer">
    <button type="button" id="save-and-close-modal" class="save"
            (click)="saveChanges(changeModeModal);">SAVE
    </button>
    <button type="button" id="close-modal" class="cancel"
            (click)="cancelChange(); changeModeModal.hide()">CLOSE
    </button>
  </div>
</app-modal>
